function formatComment(text) {
    return text
        .replace(/\\/g, '\\\\')   // екрануємо зворотні слеші
        .replace(/"/g, '\\"')     // екрануємо подвійні лапки
        .replace(/\n/g, '\\n')    // замінюємо новий рядок на \n
        .replace(/\t/g, '\\t');   // замінюємо табуляцію на \t
}

/**
 * Форматує назву колонки для MySQL:
 * - Додає лапки `назва`, якщо ім'я некоректне або зарезервоване.
 * - Інакше повертає як є (без лапок).
 */
function formatColumnName(colName) {
    // Зарезервовані слова MySQL (актуальні для 8.0+)
    const reserved = new Set([
        'accessible', 'add', 'all', 'alter', 'analyze', 'and', 'as', 'asc', 'asensitive',
        'before', 'between', 'bigint', 'binary', 'blob', 'both', 'by', 'call', 'cascade',
        'case', 'change', 'check', 'collate', 'column', 'condition', 'constraint', 'continue',
        'convert', 'create', 'cross', 'current_date', 'current_time', 'current_timestamp',
        'current_user', 'cursor', 'database', 'databases', 'day_hour', 'day_microsecond',
        'day_minute', 'day_second', 'dec', 'decimal', 'declare', 'default', 'delayed', 'delete',
        'desc', 'describe', 'deterministic', 'distinct', 'distinctrow', 'div', 'do', 'double',
        'drop', 'dual', 'each', 'else', 'elseif', 'enclosed', 'escaped', 'exists', 'exit',
        'explain', 'false', 'fetch', 'float', 'float4', 'float8', 'for', 'force', 'foreign',
        'from', 'fulltext', 'generated', 'get', 'grant', 'group', 'having', 'high_priority',
        'if', 'ignore', 'in', 'index', 'infile', 'inner', 'inout', 'insensitive', 'insert',
        'int', 'int1', 'int2', 'int3', 'int4', 'int8', 'integer', 'interval', 'into', 'io_after_gtids',
        'io_before_gtids', 'is', 'iterate', 'join', 'key', 'keys', 'kill', 'leading', 'leave',
        'left', 'like', 'limit', 'linear', 'lines', 'load', 'localtime', 'localtimestamp',
        'lock', 'long', 'longblob', 'longtext', 'loop', 'low_priority', 'master_bind',
        'master_ssl_verify_server_cert', 'match', 'maxvalue', 'mediumblob', 'mediumint',
        'mediumtext', 'middleint', 'minute_microsecond', 'minute_second', 'mod', 'modifies',
        'natural', 'not', 'no_write_to_binlog', 'null', 'numeric', 'on', 'optimize', 'optimizer_costs',
        'option', 'optionally', 'or', 'order', 'out', 'outer', 'outfile', 'partition', 'precision',
        'primary', 'procedure', 'purge', 'range', 'read', 'reads', 'read_write', 'real', 'references',
        'regexp', 'release', 'rename', 'repeat', 'replace', 'require', 'resignal', 'restrict',
        'return', 'revoke', 'right', 'rlike', 'schema', 'schemas', 'second_microsecond',
        'select', 'sensitive', 'separator', 'set', 'show', 'signal', 'smallint', 'spatial',
        'specific', 'sql', 'sqlexception', 'sqlstate', 'sqlwarning', 'sql_big_result',
        'sql_calc_found_rows', 'sql_small_result', 'ssl', 'starting', 'stored', 'straight_join',
        'table', 'terminated', 'then', 'tinyblob', 'tinyint', 'tinytext', 'to', 'trailing',
        'trigger', 'true', 'undo', 'union', 'unique', 'unlock', 'unsigned', 'update', 'usage',
        'use', 'using', 'utc_date', 'utc_time', 'utc_timestamp', 'values', 'varbinary', 'varchar',
        'varcharacter', 'varying', 'virtual', 'when', 'where', 'while', 'with', 'write', 'xor',
        'year_month', 'zerofill'
    ]);

    // Перевірки
    const hasSpecialChars = /[^a-zA-Z0-9_]/.test(colName);
    const startsWithNumber = /^[0-9]/.test(colName);
    const isReserved = reserved.has(colName.toLowerCase());

    // Якщо є спецсимволи, цифра на початку або зарезервоване слово — обгортаємо в бектики
    if (hasSpecialChars || startsWithNumber || isReserved) {
        return `\`${colName}\``;
    }

    return colName;
}

function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // const seconds = String(date.getSeconds()).padStart(2, '0');

    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * Генерує SQL код для створення таблиць MySQL на основі заданого об'єкта.
 * @param {Object} tables - Об'єкт, що описує таблиці та колонки.
 * Структура об'єкту:
 * {
 *      "table_id": {
 *          "id": "table_id",
 *          "value": {
 *              "header": {
 *                  "name": "table_name",
 *              },
*               "columns": {
*                   "column_id": {
*                       "id": "column_id",
*                       "name": "column_name",
*                       "type": "VARCHAR(255)",
*                       "isPK": false,
*                       "isFK": false,
*                       "isAutoIncrement": false,
*                       "isNN": false,
*                       "enumValues": null,
*                       "defaultValue": null,
*                       "checkValue": null,
*                       "generatedValue": null,
*
*                       "isGeneratedValueVirtual": false,
*                       "isGeneratedValueStored": false,
*                       "onUpdate": null,
*
*                       "fkRefTable": null,
*                       "fkRefColumn": null,
*                       "index": {
*                         "compositeColumns": null,
*                         "isRegular": false,
*                         "isUnique": false,
*                         "isComposite": false,
*                         "isFullText": false,
*                         "indexName": null
*                       }
*                   }
*               }
*           }
*       }
*  }
* @param {string} projectName - Ім'я проєкту (для преамбули).
* @param {string} projectVersion - Версія проєкту (для преамбули).
* @param {string} mysqlVersion - Цільова версія MySQL
* @returns {string} SQL код для створення всіх таблиць.
*/
export default function generateCode(
    tables,
    projectName = 'Core Service',
    // projectVersion = '1.4.43',
    // mysqlVersion = '8.0' // '8.0', '5.7'
) {
    const exportDate = formatDate(new Date());
    const serviceName = 'dbdesign.io';

    const statements = [];

    const commentsDefinitionsByTables = {};
    const indexesDefinitionsByTables = {};
    const foreignKeysDefinitionsByTables = {};

    // -- ----------------------------------------------
    // -- Project Name: --------- Core Service ---------
    // -- Database: ------------- MySQL ----------------
    // -- Export Date: ---------- 2024-12-21 22:10:15 --
    // -- Created By: ----------- dbdesign.io ----------
    // -- ----------------------------------------------
    // -- Project Version: ------ 1.4.43 ---------------

    const preambulaName = `Project Name: --------- ${projectName}`;
    // const preambulaVersion = `Project Version: ------ ${projectVersion}`;
    const preambulaDB = `Database: ------------- MySQL`; // ${mysqlVersion}`;
    const preambulaDate = `Export Date: ---------- ${exportDate}`;
    const preambulaCreatedBy = `Created By: ----------- ${serviceName}`;

    const preambulaLength = Math.max(
        preambulaName.length,
        // preambulaVersion.length,
        preambulaDB.length,
        preambulaDate.length,
        preambulaCreatedBy.length,
    ) + 3;

    let preambulaStatement = '';
    preambulaStatement += `-- ${'-'.repeat(preambulaLength)}`;
    preambulaStatement += `\n-- ${preambulaName} ${'-'.repeat(preambulaLength - preambulaName.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaDB} ${'-'.repeat(preambulaLength - preambulaDB.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaDate} ${'-'.repeat(preambulaLength - preambulaDate.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaCreatedBy} ${'-'.repeat(preambulaLength - preambulaCreatedBy.length - 1)}`;
    preambulaStatement += `\n-- ${'-'.repeat(preambulaLength)}`;

    statements.push(preambulaStatement);

    // ------------ TRANSACTION: START ------------
    const transactionStartStatement = 'START TRANSACTION;';
    statements.push(transactionStartStatement);

    // ------------ SET TABLE NAME MAX LENGTH ------------
    let tableNameMaxLength = 0;
    for (const tableKey in tables) {
        const table = tables[tableKey];
        let tableName = formatColumnName(table?.value?.header?.name || '');

        if (tableName.length > tableNameMaxLength) {
            tableNameMaxLength = tableName.length;
        }
    }

    // ------------ TABLES ------------
    for (const tableKey in tables) {
        const table = tables[tableKey];
        const { value: { header: { name: tableName }, columns, description: tableDescription } } = table;

        // inside 'create table' statement

        const columnsDefinitions = [];

        const primaryKeys = [];
        const primaryKeysDefinitions = [];

        const uniqueIndexes = [];
        const uniqueDefinitions = [];

        const checks = [];
        const checksDefinitions = [];

        // after of 'create table' statement

        const indexes = [];
        const indexesDefinitions = [];

        const foreignKeys = [];
        const foreignKeysDefinitions = [];

        // const comments = [];
        const commentsDefinitions = [];

        // SET COLUMN NAME MAX LENGTH
        let colNameMaxLength = 0;
        for (const columnKey in columns) {
            const col = columns[columnKey];

            let colName = formatColumnName(col.name);
            if (colName.length > colNameMaxLength) {
                colNameMaxLength = colName.length;
            }
        }

        // ------------ COLUMNS START ------------
        for (const columnKey in columns) {
            const col = columns[columnKey];

            const isColumnAutoIncrement = col.isAutoIncrement;
            const isColumnEnum = col.enumValues && Array.isArray(col.enumValues) && col.enumValues.length > 0; // && col.type === 'enum'
            const isColumnGenerated = col.generatedValue;
            const hasColumnDefault = col.defaultValue !== null && col.defaultValue !== undefined;
            const hasColumnCheck = col.checkValue;

            let colDef = '';

            // ------ COLUMN NAME ------
            const colName = formatColumnName(col.name);
            const spacesCount = colNameMaxLength - colName.length + 3;

            colDef += `${colName}${' '.repeat(spacesCount)}`;

            // ------ COLUMN TYPE ------
            if (!isColumnEnum && !isColumnGenerated) {
                colDef += `${col.type}`;
            }

            // ------ ENUM ------
            // ------ "ENUM(column1, column2)"
            if (isColumnEnum) {
                const enumList = col.enumValues.map(v => `'${v}'`).join(', ');
                colDef += `ENUM(${enumList})`;
            }

            // ------ GENERATED VALUE ------
            // ------ "GENERATED ALWAYS AS (generated_expression)"
            // ------ "GENERATED ALWAYS AS (generated_expression) VIRTUAL"
            // ------ "GENERATED ALWAYS AS (generated_expression) STORED"
            if (isColumnGenerated) {
                colDef += `GENERATED ALWAYS AS (${col.generatedValue})`;
                // colDef += ` VIRTUAL`;

                // // ------ VIRTUAL ------
                // if (col.isGeneratedValueVirtual) {
                //     colDef += ` VIRTUAL`;

                //     // ------ STORED ------
                // } else if (col.isGeneratedValueStored) {
                //     colDef += ` STORED`;
                // }
            } else {
                // ------ AUTO_INCREMENT ------
                // ------ " AUTO_INCREMENT"
                if (isColumnAutoIncrement) {
                    colDef += ` AUTO_INCREMENT`;
                }

                // ------ NOT NULL ------
                // ------ " NOT NULL"
                if (col.isNN) {
                    colDef += ` NOT NULL`;
                }

                // ------ DEFAULT VALUE ------
                // ------ " DEFAULT 'default_string'"
                // ------ " DEFAULT default_number"
                if (hasColumnDefault) {
                    // ------ STRING ------
                    if (typeof col.defaultValue === 'string') {
                        if (['CURRENT_TIMESTAMP', 'NULL'].includes(col.defaultValue.toUpperCase())) {
                            colDef += ` DEFAULT ${col.defaultValue}`;
                        } else {
                            colDef += ` DEFAULT '${col.defaultValue}'`;
                        }
                    } else if (typeof col.defaultValue === 'number') {
                        // ------ NUMBER ------
                        colDef += ` DEFAULT ${col.defaultValue}`;
                    } else {
                        // nothing;
                    }
                }

                // ------ ON_UPDATE ------
                // ------ " ON UPDATE on_update_action"
                if (col.onUpdate) {
                    colDef += ` ON UPDATE ${col.onUpdate}`;
                }

                // ------ ADD TO CHECKS (SINGLE COLUMN) ------ (MYSQL 8.0) (mysqlVersion == '8.0' && )
                if (hasColumnCheck) {
                    checks.push({
                        columnNames: [col.name],
                        checkName: col.checkName,
                        checkValue: col.checkValue,
                    });
                }
            }

            // ------ ADD TO PRIMARY KEYS ------
            if (col.isPK) {
                primaryKeys.push(col.name);
            }

            // ------ ADD TO FOREIGN KEYS ------
            if (col.isFK && col.fkRefTable && col.fkRefColumn) {
                foreignKeys.push({
                    tableName: tableName,
                    columnNames: [col.name],

                    refTableName: col.fkRefTable,
                    refColumnNames: [col.fkRefColumn],

                    onUpdateTrigger: col.onUpdateTrigger,
                    onDeleteTrigger: col.onDeleteTrigger,
                });
            }

            // ------ ADD TO INDEXES ------
            if (col.index) {
                const idx = col.index;
                // index = { isRegular, isUnique, isFullText, isComposite, indexName, compositeColumns }

                // ------ UNIQUE ------
                // if (idx.isUnique) {
                if (idx.type === 'unique') {
                    uniqueIndexes.push({
                        columnNames: [col.name],
                        type: 'unique',
                    });

                    // ------ FULLTEXT ------
                    // } else if (idx.isFullText) {
                } else if (idx.type === 'fullText') {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'fullText',
                    });

                    // ------ SPATIAL ------
                    // } else if (idx.isSpatial) {
                } else if (idx.type === 'spatial') {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'spatial',
                    });

                    // ------ REGULAR ------
                    // } else if (idx.isRegular) {
                } else {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'regular',
                    });
                }
            }

            // ------ COMMENTS ------
            if (col.description) {
                colDef += ` COMMENT "${formatComment(col.description)}"`;
            }

            columnsDefinitions.push(colDef);
        }
        // ------------ COLUMNS END ------------

        // ------------ PRIMARY KEY ------------
        // ------------ "CONSTRAINT key_name PRIMARY KEY (`column1`, `column2`)"
        if (primaryKeys.length > 0) {
            const pkName = formatColumnName(`pk_${tableName}`);
            const pkDefinition = `CONSTRAINT ${pkName} PRIMARY KEY (${primaryKeys.map(c => formatColumnName(c)).join(', ')})`;

            primaryKeysDefinitions.push(pkDefinition);
        }

        // ------------ UNIQUE INDEX ------------
        // ------------ "UNIQUE KEY `table1_col1_col2_uq_idx` (`column1`)"
        uniqueIndexes.forEach((idx, i) => {
            const columnNames = idx.columnNames || [];
            const columnNamesFormated = columnNames.map(column => formatColumnName(column)).join(', ');

            const indexName = idx.indexName || `${tableName}_${columnNames.join('_')}_uq_idx`;
            let indexDefinition = `UNIQUE KEY ${formatColumnName(indexName)} (${columnNamesFormated})`;

            uniqueDefinitions.push(indexDefinition);
        });

        // ------------ CHECK ------------ (MYSQL 8.0) (mysqlVersion == '8.0' && )
        // ------------ "CHECK (check_expression)"
        // ------------ "CONSTRAINT check_name CHECK (check_expression)"
        if (checks.length) {
            checks.forEach((chk, i) => {
                const checkName = chk.checkName || `chk_${chk.columnNames.join('_')}`;
                checksDefinitions.push(`CONSTRAINT ${formatColumnName(checkName)} CHECK (${chk.value})`);
            });
        }

        // ------------ FOREIGN KEYS ------------
        // ------------ ALTER TABLE `table1` ADD CONSTRAINT `fk_name` FOREIGN KEY (`col1`, `col2`) REFERENCES `table2`(`col1`, `col2`) ON UPDATE CASCADE ON DELETE CASCADE;
        if (foreignKeys.length) {
            for (const fk of foreignKeys) {
                const tableName = fk.tableName;
                const columnNames = fk.columnNames || [];
                const columnNamesFormated = columnNames.map(column => formatColumnName(column)).join(', ');

                const refTableName = fk.refTableName;
                const refColumnNames = fk.refColumnNames || [];
                const refColumnNamesFormated = refColumnNames.map(column => formatColumnName(column)).join(', ');

                const onUpdateTrigger = fk.onUpdateTrigger;
                const onDeleteTrigger = fk.onDeleteTrigger;

                const fkName = fk.fkName || `fk_${tableName}_${columnNames.join('_')}`;

                const spacesCount = tableNameMaxLength - tableName.length;

                let foreignKeyDef = '';
                foreignKeyDef += `ALTER TABLE ${formatColumnName(tableName)}${' '.repeat(spacesCount)} ADD CONSTRAINT ${formatColumnName(fkName)} FOREIGN KEY (${columnNamesFormated}) REFERENCES ${formatColumnName(refTableName)}(${refColumnNamesFormated})`;
                if (onUpdateTrigger) {
                    foreignKeyDef += ` ON UPDATE ${onUpdateTrigger}`;
                }
                if (onDeleteTrigger) {
                    foreignKeyDef += ` ON DELETE ${onDeleteTrigger}`;
                }

                foreignKeyDef += `;`;
                foreignKeysDefinitions.push(foreignKeyDef);
            }

            foreignKeysDefinitionsByTables[tableName] = foreignKeysDefinitions;
        }

        // ------------ INDEX ------------
        // ------------ ALTER TABLE `table1` ADD [UNIQUE | FULLTEXT | SPATIAL] INDEX `table1_col1_col2_uq_idx` (`col1`, `сol2`) USING [BTREE | HASH];
        if (indexes.length) {
            indexes.forEach((idx, i) => {
                const tableName = idx.tableName;
                const columnNames = idx.columnNames || [];
                const columnNamesFormated = columnNames.map(column => formatColumnName(column)).join(', ');

                let indexType = '';
                let indexTypeShort = '';

                if (idx.type === 'unique') {
                    indexType = 'UNIQUE';
                    indexTypeShort = 'uq';
                } else if (idx.type === 'fullText') {
                    indexType = 'FULLTEXT';
                    indexTypeShort = 'txt';
                } else if (idx.type === 'spatial') {
                    indexType = 'SPATIAL';
                    indexTypeShort = 'sptl';
                } else if (idx.type === 'regular') {
                    // REGULAR
                    // nothing.
                } else {
                    // REGULAR
                    // nothing.
                }

                const indexName = idx.indexName || `${tableName}_${columnNames.join('_')}_${indexTypeShort ? indexTypeShort + '_' : ''}idx`;
                let indexDefinition = `ALTER TABLE ${formatColumnName(tableName)} ADD ${indexType ? indexType + ' ' : ''}INDEX ${formatColumnName(indexName)} (${columnNamesFormated});`;

                indexesDefinitions.push(indexDefinition);
            });

            indexesDefinitionsByTables[tableName] = indexesDefinitions;
        }

        // ------------ COMMENTS ------------
        // ------------ ALTER TABLE `table1` COMMENT = 'new table comment';
        if (tableDescription) {
            let commentDefinition = `ALTER TABLE ${formatColumnName(tableName)} COMMENT "${formatComment(tableDescription)}";`;
            commentsDefinitions.push(commentDefinition);

            commentsDefinitionsByTables[tableName] = commentsDefinitions;
        }

        // ------------ RESULT ------------------------------------------------------------------------------------------------
        // ------------ CREATE TABLE ------------
        const isColumns = columnsDefinitions.length;
        const isPrimary = primaryKeysDefinitions.length;
        const isUnique = uniqueDefinitions.length;
        const isCheck = checksDefinitions.length;

        let createStatement = '';
        createStatement += `-- ---------- TABLE ${tableName.toUpperCase()} -----------\n`;
        createStatement += `CREATE TABLE IF NOT EXISTS ${formatColumnName(tableName)} (`;

        if (isColumns) {
            createStatement += `\n  ${columnsDefinitions.join(',\n  ')}${isPrimary || isUnique || isCheck ? ',\n  ' : ''}`;
        }

        if (isPrimary && isUnique) {
            // createStatement += '  -- PRIMARY / UNIQUE';
            createStatement += `\n  ${[...primaryKeysDefinitions, ...uniqueDefinitions].join(',\n  ')}`; //${isCheck ? ',\n  ' : ''}`;
        } else if (isPrimary) {
            // createStatement += '  -- PRIMARY';
            createStatement += `\n  ${primaryKeysDefinitions.join(',\n  ')}`; //${isCheck ? ',\n  ' : ''}`;
        } else if (isUnique) {
            // createStatement += '  -- UNIQUE';
            createStatement += `\n  ${uniqueDefinitions.join(',\n  ')}`; //${isCheck ? ',\n  ' : ''}`;
        }

        if (isCheck) {
            // createStatement += '  -- CHECK';
            createStatement += `\n  ${checksDefinitions.join(',\n  ')}`;
        }
        // createStatement += `\n) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4;`;
        createStatement += `\n);`;

        statements.push(createStatement);
    }

    // ------------ COMMENTS: FINAL ------------
    const commentsKeys = Object.keys(commentsDefinitionsByTables);
    if (commentsKeys.length) {
        let commentStatements = [];
        const commentsHeaderStatement = "-- ---------- COMMENTS ---------------";
        commentStatements.push(commentsHeaderStatement);

        commentsKeys.forEach(commentKey => {
            const commentsDefs = commentsDefinitionsByTables[commentKey];
            commentStatements.push(commentsDefs.join('\n'));
        });
        statements.push(commentStatements.join('\n'));
    }

    // ------------ INDEXES: FINAL ------------
    const indexesKeys = Object.keys(indexesDefinitionsByTables);
    if (indexesKeys.length) {
        let indexStatements = [];
        const indexesHeaderStatement = "-- ---------- INDEXES ----------------";
        indexStatements.push(indexesHeaderStatement);

        indexesKeys.forEach(indexKey => {
            const indexesDefs = indexesDefinitionsByTables[indexKey];
            indexStatements.push(indexesDefs.join('\n'));
        })
        statements.push(indexStatements.join('\n'));
    }

    // ------------ FOREIGN KEYS: FINAL ------------
    const fkKeys = Object.keys(foreignKeysDefinitionsByTables);
    if (fkKeys.length) {
        let fkStatements = [];
        const fkHeaderStatement = "-- ---------- FOREIGN KEYS -----------\n";

        fkKeys.forEach(fkKey => {
            const fkDefs = foreignKeysDefinitionsByTables[fkKey];
            fkStatements.push(fkDefs.join('\n'));
        })
        statements.push(fkHeaderStatement + fkStatements.join('\n'));
    }

    // ------------ TRANSACTION: END ------------
    const transactionEndStatement = 'COMMIT;';
    statements.push(transactionEndStatement);

    return statements.join('\n\n') + '';
}
